export default __webpack_public_path__ + "static/media/katieKozmaMobile.6476fcee.jpg";